/**
 * <countdown-timer>
 * Cuenta regresiva compartida (sección "Contador de promoción" y aviso del carrito).
 *
 * Atributos:
 *   data-deadline        fecha ISO con zona horaria, p. ej. "2026-08-31T23:59:00-06:00"
 *   data-inline          modo texto compacto ("3d 04:12:33") escrito en el propio elemento;
 *                        sin este atributo actualiza los hijos [data-dd] [data-hh] [data-mm] [data-ss]
 *   data-expired-action  "hide" oculta al terminar el elemento indicado en data-hide-target
 *                        (selector buscado con closest); sin él se oculta el propio elemento
 *   data-expired-text    en vez de ocultar, muestra este texto al terminar (solo modo normal)
 *
 * El elemento sobrevive a los re-render del cajón del carrito: si el nodo se
 * recrea, connectedCallback vuelve a arrancar el intervalo.
 */
(function () {
  if (customElements.get('countdown-timer')) return;

  var pad = function (n) {
    return (n < 10 ? '0' : '') + n;
  };

  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.deadlineMs = Date.parse(this.dataset.deadline || '');
      if (!this.deadlineMs || isNaN(this.deadlineMs)) {
        this.hidden = true;
        return;
      }
      this.tick();
      clearInterval(this.timerId);
      this.timerId = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timerId);
    }

    tick() {
      var ms = this.deadlineMs - Date.now();
      if (ms <= 0) {
        clearInterval(this.timerId);
        this.expire();
        return;
      }
      var total = Math.floor(ms / 1000);
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;

      if (this.hasAttribute('data-inline')) {
        this.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        return;
      }

      this.setCell('dd', d);
      this.setCell('hh', h);
      this.setCell('mm', m);
      this.setCell('ss', s);

      // Con menos de un día, la celda de días sobra.
      var daysCell = this.querySelector('[data-cell-dias]');
      if (daysCell) daysCell.hidden = d === 0;
    }

    setCell(name, value) {
      var el = this.querySelector('[data-' + name + ']');
      if (!el) return;
      var text = pad(value);
      if (el.textContent !== text) el.textContent = text;
    }

    expire() {
      if (this.dataset.expiredText && !this.hasAttribute('data-inline')) {
        this.innerHTML = '';
        var p = document.createElement('p');
        p.className = 'countdown-timer__expired';
        p.textContent = this.dataset.expiredText;
        this.appendChild(p);
        return;
      }
      var target = this;
      if (this.dataset.expiredAction === 'hide' && this.dataset.hideTarget) {
        target = this.closest(this.dataset.hideTarget) || this;
      }
      target.style.display = 'none';
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
})();
